import { Footer } from '~shared/ui/footer';
import { Screen, ScreenHeader } from '~shared/ui/screen';

import { ButterflyMoney as ButterflyMoneyIllustration } from '@breezeventures/ui-kit/next/illustrations/medium/butterfly-money';
import { Typography } from '@breezeventures/ui-kit/typography';

type BusinessStartProps = {
  onBack?: () => void;
  onClose: () => void;
  onSubmit: () => void;
};

export const BusinessStart = ({
  onBack,
  onClose,
  onSubmit,
}: BusinessStartProps) => {
  return (
    <Screen
      header={<ScreenHeader onBack={onBack} onClose={onClose} />}
      footer={<Footer submitButtonText="Next" onSubmit={onSubmit} />}
    >
      <div className="my-auto flex flex-col items-center">
        <ButterflyMoneyIllustration alt="" />

        <div className="mt-8 flex flex-col items-center gap-3 text-center">
          <Typography.Title size="s" className="px-2">
            Tell us about your&nbsp;business, boss!
          </Typography.Title>
          <Typography.Text size="m" color="secondary">
            Share the&nbsp;main&nbsp;details to&nbsp;get
            your&nbsp;account&nbsp;ready.
          </Typography.Text>
        </div>
      </div>
    </Screen>
  );
};
